import { ChevronsLeftIcon, ChevronsRightIcon } from "lucide-react";
import { FC } from "react";
import { useSkyViewStore } from "~/features/skyView/store";
import { useMobile } from "~/hooks/use-mobile";

type ExpandableControlProps = {};

export const ExpandableControl: FC<ExpandableControlProps> = () => {
  const { isExpanded, toggleExpanded } = useSkyViewStore();
  const { isMobile } = useMobile();

  if (isMobile) {
    return null;
  }

  if (!isExpanded) {
    return (
      <div className="flex h-full items-center">
        <div
          className="flex h-12 w-6 cursor-pointer items-center justify-center rounded-l-full border border-r-0 border-border bg-muted shadow-sm transition-colors hover:bg-accent"
          onClick={toggleExpanded}
        >
          <ChevronsLeftIcon className="h-4 w-4" />
        </div>
      </div>
    );
  }

  return (
    <div
      className={
        "w-3 h-screen relative border-r border-l border-border flex items-center justify-center cursor-pointer hover:bg-accent"
      }
      onClick={toggleExpanded}
    >
      <ChevronsRightIcon className="w-2 h-2" />
    </div>
  );
};
